// extracted by mini-css-extract-plugin
export default {"default":"TicketName-module__default___3r-1j"};